var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4506 5.33839C12.2713 5.52132 12.1709 5.76725 12.1709 6.0234C12.1709 6.27954 12.2713 6.52548 12.4506 6.7084L14.0164 8.27412C14.1993 8.45342 14.4452 8.55386 14.7014 8.55386C14.9575 8.55386 15.2034 8.45342 15.3864 8.27412L19.0756 4.58489C19.5677 5.67227 19.7166 6.88379 19.5027 8.058C19.2888 9.2322 18.722 10.3133 17.8781 11.1573C17.0341 12.0012 15.953 12.5679 14.7788 12.7819C13.6046 12.9958 12.3931 12.8468 11.3057 12.3548L4.54374 19.1167C4.15444 19.506 3.62643 19.7248 3.07587 19.7248C2.52532 19.7248 1.99731 19.506 1.60801 19.1167C1.21871 18.7274 1 18.1994 1 17.6489C1 17.0983 1.21871 16.5703 1.60801 16.181L8.36997 9.41906C7.87791 8.33167 7.72892 7.12015 7.94286 5.94595C8.1568 4.77174 8.72352 3.69062 9.56747 2.84667C10.4114 2.00271 11.4925 1.436 12.6668 1.22206C13.841 1.00811 15.0525 1.1571 16.1399 1.64916L12.4604 5.32861L12.4506 5.33839Z",
    stroke: "#2A2E3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.099c4c053eedfcc1f799d4698d48b0fd.svg";
export { ForwardRef as ReactComponent };